/**
 * Canonical copy for LoadingSpinner usage.
 * - Verifying access: auth gates on non–exam-form routes (ProtectedRoute, MSAL overlay).
 * - Loading form: `/examform` (FormView, route Suspense fallbacks, lazy chunks).
 * - Loading exam details: exam workspace (`/exam-workspace/:examId`) when fetching workspace payload (e.g. back from form).
 * - Loading exam files: diagnostics and medical records rail tiles while the shared file list is loading.
 */
export const VERIFYING_ACCESS_MESSAGE = 'Verifying your access...';
export const VERIFYING_ACCESS_ARIA_LABEL = 'Verifying your access';

export const LOADING_FORM_MESSAGE = 'Loading form...';
export const LOADING_FORM_ARIA_LABEL = 'Loading form';

export const LOADING_EXAM_DETAILS_MESSAGE = 'Loading exam details...';
export const LOADING_EXAM_DETAILS_ARIA_LABEL = 'Loading exam details';

export const LOADING_EXAM_FILES_MESSAGE = 'Loading files...';
export const LOADING_EXAM_FILES_ARIA_LABEL = 'Loading exam files';
